import { z } from "zod";

export const FieldTypes = [
  "text",
  "email",
  "textarea",
  "number",
  "phonenumber",
  "checkbox",
  "select",
  "multiselect",
  "date",
  "time",
] as const;

export const FieldOptionSchema = z.object({
  label: z.string(),
  value: z.string(),
});

export const FormFieldSchema = z.object({
  id: z.string(),
  referenceId: z.string().nullable().optional(),
  name: z.string(),
  label: z.string(),
  type: z.enum(FieldTypes),
  placeholder: z.string().nullable().optional(),
  required: z.boolean().default(false).nullable().optional(),
  options: z.array(FieldOptionSchema).nullable().optional(),
  defaultValue: z.any().nullable().optional(),
  strict: z.boolean().default(false).nullable().optional(),
});

export const FormSchema = z.object({
  id: z.string(),
  // title: z.string(),
  fields: z.array(FormFieldSchema),
});

export type FieldOption = z.infer<typeof FieldOptionSchema>;
export type DynamicFormField = z.infer<typeof FormFieldSchema>;
export type FormDefinition = z.infer<typeof FormSchema>;
export type FieldType = (typeof FieldTypes)[number];
